import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString, ValidateNested, IsOptional } from "class-validator";

export class GetBankStatementReservation {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsNumber()
  grandTotal!: number;
  @Expose()
  @IsNumber()
  exchangeRate!: number;
  @Expose()
  @IsNumber()
  leftToPay!: number;
  @Expose()
  @IsNumber()
  settled!: number;
  @Expose()
  @IsOptional()
  @IsString()
  reservationNumber!: string;
  @Expose()
  @IsString()
  contractor!: string;
  @Expose()
  @IsString()
  currency!: string;
  @Expose()
  @IsBoolean()
  isSettledWithSelectedBankStatementItem!: boolean;
  @Expose()
  @IsNumber()
  settledWithSelectedBankStatementItemCount!: number;
}

export class GetBankStatementReservationsResponse extends GenericTableResponse<GetBankStatementReservation> {
  @Type(() => GetBankStatementReservation)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GetBankStatementReservation>;
}
